import NoFeature from './NoFeature';

export default NoFeature;
